<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input" title="Tìm kiếm theo họ tên khách">
                <div class="label">
                  {{ 'Thông tin khách' }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.keyword"
                    type="text"
                    placeholder="Tìm kiếm theo họ tên khách"
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Ngày' }}
                </div>
                <div class="child-w-80">
                  <CalendarSelect
                    v-model="searchParams.date"
                    style="display: block; width: 100%"
                    mode="date"
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Nguồn' }}
                </div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.sourceId"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in agencyOptions"
                      :key="item.id"
                      :label="item.desc"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>

          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Đoàn' }}
                </div>
                <div
                  class="child-w-80"
                  style="display: flex; gap: 10px; width: 100%"
                >
                  <el-select
                    v-model="searchParams.bookingId"
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="getBookingGroupSelectOptions"
                  >
                    <el-option
                      v-for="item in groupSelectOption"
                      :key="item.id"
                      :value="item.id"
                      :label="`${item.booking_code} - ${item.name}`"
                    >
                      <span style="float: left">{{ item.name }}</span>
                      <span
                        style="
                          float: right;
                          color: var(--el-text-color-secondary);
                          font-size: 13px;
                        "
                        >{{ item.booking_code }}</span
                      ></el-option
                    >
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Hạng phòng' }}
                </div>
                <div class="child-w-80">
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['id', 'code', 'name']"
                    :selected-index-field-value="searchParams.roomLevelId"
                    :value="searchParams.roomLevelId"
                    :rows="roomLevelRows"
                    :columns="roomLevelCols"
                    :dropdown-width="600"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectRoomLevel"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          <!-- {{
                                `${selectedData?.code || ''} - ${
                                  selectedData?.name || ''
                                }`
                              }} -->
                          {{ selectedData?.name }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Trạng thái gán' }}
                </div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.isAssignGuest"
                    placeholder="Vui lòng chọn"
                  >
                    <el-option
                      v-for="item in isAssignGuestOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        class="agGrid"
        dom-layout="scroll"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        :is-row-selectable="params => !params.data?.isFullWidthRow"
        @selectionChanged="
          value => {
            selectedRows = value
          }
        "
        @cellContextMenu="handleOpenContextMenu"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>

    <div class="button-containers mb-0">
      <button
        class="btn primary small"
        :disabled="!(selectedRows.length == 1 && !selectedRows[0]?.room_id)"
        @click="dialogAssignRoomVisible = true"
      >
        {{ 'Gán phòng' }}
      </button>
      <button
        class="btn primary small"
        :disabled="
          selectedRows.length <= 0 ||
          !selectedRows.every(item => !!item?.room_id)
        "
        @click="onCheckin"
      >
        {{ 'Check-in' }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRows.length !== 1"
        @click="onOpenUpdateBookingRoom"
      >
        {{ 'Sửa đặt phòng' }}
      </button>
      <button class="btn primary small">
        {{ 'Xuất excel' }}
      </button>

      <!-- <button class="btn primary small">
        {{ 'Thêm khách' }}
      </button> -->
    </div>

    <!-- Sua dat phong dialog -->
    <el-dialog
      :visible.sync="isBookingRoomDialogOpened"
      title="Thông tin đặt phòng"
      width="80%"
      append-to-body
      @close="onCloseBookingRoomDialog"
    >
      <BookingRoomForm
        ref="BookingRoomForm"
        :action="bookingRoomFormAction"
        :record-data="bookingRoomFormData"
      ></BookingRoomForm>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button
          v-if="bookingRoomFormAction == 'create'"
          class="btn primary small"
          @click="onCreateBookingRoom"
        >
          Thêm
        </button>
        <button
          v-if="bookingRoomFormAction == 'edit'"
          class="btn primary small"
          @click="onUpdateBookingRoom"
        >
          Cập nhật
        </button>
        <button
          class="btn primary small outline"
          @click="onCloseBookingRoomDialog"
        >
          Đóng
        </button>
      </span>
    </el-dialog>

    <!-- GROUP DIALOG SEARCH -->
    <el-dialog
      :title="'Tìm kiếm đoàn'"
      :visible.sync="dialogGroupVisible"
      width="90%"
      :close-on-click-modal="false"
      @close="dialogGroupVisible = false"
    >
      <div>
        <search-comp @onSearch="onSearchGroup" @onReset="onResetSearchGroup">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Thông tin đoàn' }}
                    </div>
                    <div>
                      <input v-model="groupSearchParams.info" type="text" />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Công ty, đại lý du lịch' }}
                    </div>
                    <div>
                      <input v-model="groupSearchParams.agent" type="text" />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Trạng thái đoàn' }}
                    </div>
                    <div>
                      <el-select
                        v-model="groupSearchParams.groupStatus"
                        multiple
                        collapse-tags
                        placeholder="Vui lòng chọn"
                      >
                        <el-option
                          v-for="item in groupStatusOptions"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Trạng thái đặt phòng' }}
                    </div>
                    <div>
                      <el-select
                        v-model="groupSearchParams.status"
                        multiple
                        collapse-tags
                        placeholder="Vui lòng chọn"
                      >
                        <el-option
                          v-for="item in roomStatusOptions"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Ngày đến' }}
                    </div>
                    <div>
                      <CalendarRange
                        v-model="groupSearchParams.firstArrival"
                        style="display: block; width: 100%"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Ngày đi' }}
                    </div>
                    <div>
                      <CalendarRange
                        v-model="groupSearchParams.lastDepDate"
                        style="display: block; width: 100%"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Đặt phòng qua ngày' }}
                    </div>
                    <div>
                      <CalendarSelect
                        v-model="groupSearchParams.bookStayOverDate"
                        style="display: block; width: 100%"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Ngày nhả phòng' }}
                    </div>
                    <div>
                      <CalendarSelect
                        v-model="groupSearchParams.releaseDate"
                        style="display: block; width: 100%"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
      </div>

      <div v-loading="groupLoading" class="grid-scroll mt-30">
        <GridVx
          ref="agGrid"
          style="height: calc(40px + 340px + 10px)"
          :columns="groupColumns"
          :rows="groupRowss"
          row-selection="single"
          class="agGrid"
          @rowClicked="row => (groupSelectedRow = row[0])"
        />
      </div>
      <div class="grid-bottom">
        <GridPaging
          target="agGrid"
          :total-size="groupSearchParams.totalPage"
          :page-num="groupSearchParams.pageNum"
          @pageChanged="onPageChangedGroup"
          @onPageSizeChange="onPageSizeChangeGroup"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogGroupVisible = false"
          >
            {{ $t('config.account.assign.btn.close') }}
          </button>
          <button
            class="btn primary small"
            :disabled="!groupSelectedRow"
            @click="
              searchParams.bookingId = groupSelectedRow.id
              dialogGroupVisible = false
            "
          >
            {{ $t('config.account.assign.btn.submit') }}
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- Context Menu -->
    <AssignRoomGridContextMenu
      id="context-menu"
      :is-show="ctxMenuState"
      :data="ctxMenuRow"
    />

    <!-- <AssignRoomDialog
      v-model="dialogAssignRoomVisible"
      :data="selectedRows"
    /> -->
    <AssignRoomSingleDialog
      v-model="dialogAssignRoomVisible"
      :data="selectedRows[0]"
      @submit="fnGetAssignRoom"
    />
  </div>
</template>

<script>
import { callGetBookingGroup, callGetRoomLevel } from './utils/commonApiCall'
import paginationMixin from '@/mixins/paginationMixin'
import ctxMenuMixin from '@/mixins/ctxMenuMixin'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import AssignRoomSingleDialog from './components/AssignRoomSingleDialog.vue'
import BookingRoomForm from '@/components/resources/booking/BookingRoomForm'
import AssignRoomGridContextMenu from './components/AssignRoomGridContextMenu.vue'

import { getBookingGroup } from '@/api/reception/common'
import { checkin, getAssignRoom } from '@/api/reception/reception'
import {
  getBookingRoom,
  updateBookingRoom
} from '@/api/booking_service/booking'
import { notifyError, notifySuccess } from '@/utils/toast'
import { getSourceListApi } from '@/api/common/source'

export default {
  components: {
    BookingRoomForm,
    CalendarSelect,
    CalendarRange,
    AssignRoomSingleDialog,
    AssignRoomGridContextMenu
  },
  mixins: [paginationMixin, ctxMenuMixin],
  data() {
    return {
      // sua dat phong dialog
      isBookingRoomDialogOpened: false,
      bookingRoomFormAction: 'edit',
      bookingRoomFormData: null,

      // search panel
      searchParams: {
        keyword: null,
        date: null,
        sourceId: null,
        bookingId: null,
        roomLevelId: null,
        isAssignGuest: null
      },
      defaultSearchParams: {
        keyword: null,
        date: null,
        sourceId: null,
        bookingId: null,
        roomLevelId: null,
        isAssignGuest: null
      },
      groupSelectOption: [],
      groupRows: [],
      groupCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      roomLevelRows: [],
      roomLevelCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      // table
      rows: [],
      selectedRows: [],
      loading: false,

      // dialog
      dialogGroupVisible: false,
      dialogAssignRoomVisible: false,

      // group dialog for search
      groupSearchParams: {
        pageSize: 10,
        pageNum: 1,
        totalPage: null,
        orderBy: null,
        orderTp: null,
        info: null,
        agent: null,
        firstArrival: {
          start: null,
          end: null
        },
        lastDepDate: {
          start: null,
          end: null
        },
        roomDate: {
          start: null,
          end: null
        },
        releaseDate: null,
        bookStayOverDate: null,
        status: [],
        isRoomBooking: null,
        isRoomCo: null,
        groupStatus: []
      },
      defaultGroupSearchParams: {
        pageSize: 10,
        pageNum: 1,
        totalPage: undefined,
        orderBy: undefined,
        orderTp: undefined,
        info: undefined,
        agent: undefined,
        firstArrival: {
          start: undefined,
          end: undefined
        },
        lastDepDate: {
          start: undefined,
          end: undefined
        },
        roomDate: {
          start: undefined,
          end: undefined
        },
        releaseDate: undefined,
        bookStayOverDate: undefined,
        status: [],
        isRoomBooking: undefined,
        isRoomCo: undefined,
        groupStatus: []
      },
      groupLoading: false,
      groupColumns: [
        {
          headerName: 'Trạng thái',
          field: 'status'
        },
        {
          headerName: 'Xác nhận',
          field: 'confirm_code'
        },
        {
          headerName: 'Mã đoàn',
          field: 'booking_code'
        },
        {
          headerName: 'Mã định danh ngoài',
          field: 'external_id'
        },
        {
          headerName: 'Tên đoàn',
          field: 'name'
        },
        {
          headerName: 'Đại lý du lịch',
          field: 'agent_name'
        },
        {
          headerName: 'Ngày đến đầu',
          field: 'first_arrival_date'
        },
        {
          headerName: 'Ngày đi cuối',
          field: 'last_departure_date'
        },
        {
          headerName: 'Người tạo',
          field: 'create_user_id'
        },
        {
          headerName: 'Thời gian tạo',
          field: 'create_date'
        },
        {
          headerName: 'Ghi chú',
          field: 'note'
        }
      ],
      groupRowss: [],
      groupSelectedRow: null,

      // el select
      isAssignGuestOptions: [
        { value: null, label: 'Tất cả' },
        { value: false, label: 'Đã gán' },
        { value: true, label: 'Chưa gán' }
      ],

      // multi select
      initAssignStatus: ['Chưa gán'],
      assignStatus: [],
      assignStatusOptions: [
        {
          label: 'Chưa gán',
          value: false
        },
        {
          label: 'Đã gán',
          value: true
        }
      ],
      agencyOptions: [],
      initGroupStatus: [],
      // groupStatus: [],
      groupStatusOptions: [
        { value: 1, name: 'Có khách đặt phòng' },
        { value: 2, name: 'Có khách đang ở' },
        { value: 3, name: 'Gồm đoàn trả phòng' },
        { value: 4, name: 'Đoàn bị hủy' },
        { value: 5, name: 'Có khách đã trả phòng' }
      ],
      initRoomStatus: ['Definite', 'Seri', 'Tentative', 'Waiting'],
      // roomStatus: [],
      roomStatusOptions: [
        { value: 1, name: 'Definite' },
        { value: 2, name: 'Tentative' },
        { value: 3, name: 'Seri Booking' },
        { value: 4, name: 'Waiting' }
      ],

      // context menu grid
      ctxMenuState: false,
      ctxMenuRow: null
    }
  },

  computed: {
    columns() {
      return [
        // {
        //   headerName: '',
        //   field: '',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        // },
        // {
        //   headerName: 'TT',
        //   field: ''
        // },
        {
          headerName: 'Đặt phòng',
          field: 'recode',
          valueGetter: params => {
            if (window.isHeaderRow(params)) {
              return `${params.data.traveller_type}: ${params.data.room_booking_code}`
            }
          },
          colSpan: params => {
            if (window.isHeaderRow(params)) {
              return 30
            } else {
              return 1
            }
          },
          cellClassRules: {
            'colspan-cell': params => window.isHeaderRow(params)
          },
          width: 150
        },
        {
          headerName: 'Khách hàng',
          field: 'full_name',
          valueGetter(params) {
            return params.data.last_name + ' ' + params.data.first_name
          }
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_level_nm',
          width: 180
        },
        {
          headerName: 'Phòng',
          field: 'room_num',
          width: 120
        },
        {
          headerName: 'Ngày đến',
          field: 'arrive_date',
          valueFormatter: params => {
            return params.value.split(' ')[0]
          },
          maxWidth: 150
        },
        {
          headerName: 'Ngày đi',
          field: 'depart_date',
          valueFormatter: params => {
            return params.value.split(' ')[0]
          },
          maxWidth: 150
        },
        {
          headerName: 'Giờ C/I',
          field: 'check_in_date'
        },
        {
          headerName: 'Giờ C/O',
          field: 'check_out_date'
        },
        {
          headerName: 'Đoàn',
          field: 'booking_nm'
        },
        {
          headerName: 'Công ty, đại lý du lịch',
          field: 'agent_nm'
        },
        {
          headerName: 'Giới tính',
          field: 'gender',
          valueFormatter(params) {
            switch (params.value) {
              case 1:
                return 'Nam'
              case 2:
                return 'Nữ'
              default:
                return 'Không xác định'
            }
          },
          maxWidth: 100
        },
        {
          headerName: 'Danh xưng',
          field: 'name',
          maxWidth: 100
        },
        {
          headerName: 'Hộ chiếu/CMND',
          field: ''
        },
        {
          headerName: 'Quốc tịch',
          field: 'nationality_nm'
        },
        {
          headerName: 'Địa chỉ 1',
          field: 'address_1'
        },
        {
          headerName: 'Số điện thoại',
          field: 'phone_number'
        },
        {
          headerName: 'Email',
          field: 'email'
        },
        {
          headerName: 'Ghi chú',
          field: 'note'
        },
        {
          headerName: 'Tài khoản công nợ',
          field: 'debit_acc_nm'
        }
      ]
    }
  },

  watch: {
    initAssignStatus: {
      immediate: true,
      handler(values) {
        this.assignStatus = this.assignStatusOptions.filter(x =>
          values.includes(x['label'])
        )
      }
    },
    initGroupStatus: {
      immediate: true,
      handler(values) {
        this.groupStatus = this.groupStatusOptions.filter(x =>
          values.includes(x['label'])
        )
      }
    },
    initRoomStatus: {
      immediate: true,
      handler(values) {
        this.roomStatus = this.roomStatusOptions.filter(x =>
          values.includes(x['label'])
        )
      }
    }
  },

  async mounted() {
    this.roomLevelRows = await callGetRoomLevel()
    this.groupRows = await callGetBookingGroup()
    await this.getAgencyOptions()

    window.isHeaderRow = params => {
      return !params.data.sub_booking_group_id
    }

    this.onSearch()

    // search pannel in dialog
    this.onSearchGroup()

    // Listner
    this.contextListener()
    this.clickListener()

    this.keyupListener()
    this.resizeListener()
  },

  methods: {
    async getAgencyOptions() {
      await getSourceListApi({
        isActive: 1
      })
        .then(response => {
          this.agencyOptions = response.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    // sua dat phong dialog
    async onOpenUpdateBookingRoom() {
      const selectedRoom = this.selectedRows[0]
      // this.$router.push(
      //   '/reservation/new_reservation?action=edit&id' +
      //     selectedRoom.room_booking_code
      // )
      if (selectedRoom?.sub_booking_group_id != null) {
        const bookingRoom = await getBookingRoom(
          selectedRoom?.sub_booking_group_id
        )
          .then(res => {
            return res.data
          })
          .catch(() => {
            this.$message({
              type: 'error',
              message: 'Đã có lỗi xảy ra'
            })
          })

        if (bookingRoom == null) {
          return
        }

        this.bookingRoomFormData = bookingRoom
        this.isBookingRoomDialogOpened = true
        this.bookingRoomFormAction = 'edit'
        // this.$refs.BookingRoomForm.hydrateForm(bookingRoom)
        console.debug('selectedRoom', bookingRoom)
      }
    },
    async updateBookingRoom(id, payload) {
      await updateBookingRoom(id, payload)
        .then(res => {
          notifySuccess(res?.message)
          return true
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return false
        })
    },
    async onUpdateBookingRoom() {
      const payload = this.$refs.BookingRoomForm.dehydrateForm()

      if (this.bookingRoomFormData.id) {
        if (
          !(await this.updateBookingRoom(this.bookingRoomFormData.id, payload))
        ) {
          await this.onSearchGroup()
          return
        }
      }

      Object.assign(
        this.formData.booking_room[this.bookingRoomTableIndex],
        payload
      )
      this.onCloseBookingRoomDialog()
      this.$refs.BookingFormRoomTable.$refs.bookingRoomTable.gridOptions.api.refreshCells(
        {
          force: true
        }
      )
    },
    onCloseBookingRoomDialog() {
      this.isBookingRoomDialogOpened = false
      this.fnGetAssignRoom()
    },

    // handle event
    onSelectGroup(data) {
      this.searchParams.bookingId = data?.id || null
    },
    onSelectRoomLevel(data) {
      this.searchParams.roomLevelId = data?.id || null
    },
    onCheckin() {
      this.fnCheckin(this.selectedRows.map(item => item?.sub_booking_group_id))
    },

    // Context menu
    handleOpenContextMenu(event) {
      console.log('MENU::', event)
      this.ctxMenuRow = event.data
    },

    contextListener() {
      document.addEventListener('contextmenu', e => {
        const row = this.clickInsideCtxMenu(e, 'agGrid')
        console.debug('ROW::', row, e.target)
        if (
          row &&
          (e.target.classList.contains('ag-cell') ||
            e.target.classList.contains('ag-row')) &&
          e.target.classList.contains('colspan-cell')
        ) {
          this.positionMenu(e, '#context-menu')
          // open contextmenu
          this.ctxMenuState = true
          e.preventDefault()
        } else {
          this.ctxMenuState = false
        }
      })
    },
    clickListener() {
      document.addEventListener('click', e => {
        this.ctxMenuState = false
      })
    },
    keyupListener() {
      window.onkeyup = e => {
        if (e.keyCode === 27) {
          this.ctxMenuState = false
        }
      }
    },
    resizeListener() {
      window.onresize = e => {
        this.ctxMenuState = false
      }
    },

    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetAssignRoom()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetAssignRoom()
    },

    //
    onSearch() {
      this.pageParams.pageNum = 1
      this.fnGetAssignRoom()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.onSearch()
    },

    // handle api call
    fnGetAssignRoom() {
      const query = {
        ...this.searchParams,
        pageSize: this.pageParams.pageSize,
        pageNum: this.pageParams.pageNum
      }
      getAssignRoom(query)
        .then(res => {
          if (!res.is_error) {
            // this.rows = res.data
            this.pageParams.pageNum = res.page_num
            this.pageParams.totalPage = Math.ceil(res.total / res.page_size)

            this.rows = res.data.map(item => {
              if (!item?.sub_booking_group_id) {
                return {
                  ...item
                  // isFullWidthRow: true,
                  // name: `${item.traveller_type}: ${item.room_booking_code}`
                }
              } else {
                return item
              }
            })
            this.$nextTick(() => {
              this.$refs.agGrid.autoSizeAll()
            })
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message
          notifyError(message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fnCheckin(data) {
      checkin(data)
        .then(data => {
          if (!data.is_error) {
            this.$message({
              message: data.message,
              type: 'success'
            })

            this.onResetSearch()
          }
          //  else {
          // throw new Error(data)
          // }
        })
        .catch(error => {
          const message = error.response?.data?.message
          notifyError(message)
        })
    },

    // ==================================================
    // only dialog methods here:
    onPageChangedGroup(pageNum) {
      this.groupSearchParams.pageNum = pageNum
      this.onSearchGroup()
    },
    onPageSizeChangeGroup(pageSize) {
      this.groupSearchParams.pageSize = pageSize
      this.groupSearchParams.pageNum = 1
      this.onSearchGroup()
    },
    onSearchGroup() {
      // handle search params
      const query = {
        ...this.groupSearchParams,
        firstArrivalFrom: this.groupSearchParams.firstArrival.start,
        firstArrivalTo: this.groupSearchParams.firstArrival.end,
        lastDepDateFrom: this.groupSearchParams.lastDepDate.start,
        lastDepDateTo: this.groupSearchParams.lastDepDate.end,
        roomDateFrom: this.groupSearchParams.roomDate.start,
        roomDateTo: this.groupSearchParams.roomDate.end,
        isRoomBooking: !!this.groupSearchParams.groupStatus.includes(1),
        isRoomCo: !!this.groupSearchParams.groupStatus.includes(5),
        pageNum: 1
      }
      this.fnGetBookingGroup(query)
    },
    onResetSearchGroup() {
      this.groupSearchParams = { ...this.defaultGroupSearchParams }
      this.onSearchGroup()
    },

    async getBookingGroupSelectOptions(keyword) {
      const query = {
        info: keyword,
        isRoomBooking: true,
        pageSize: 20,
        pageNum: 1
      }
      await getBookingGroup(query)
        .then(res => {
          this.groupSelectOption = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },

    // api call
    async fnGetBookingGroup(query) {
      this.groupLoading = true
      let res = null
      try {
        res = await getBookingGroup(query)
        this.groupRowss = res.data
        this.groupSearchParams.totalPage = Math.ceil(
          res.total / this.groupSearchParams.pageSize
        )
        if (res.is_error) {
          throw new Error(res)
        }
      } catch (error) {
        console.log(error)
        this.$message({
          message: 'Lỗi lấy dữ liệu!',
          type: 'error'
        })
      } finally {
        //
        this.groupLoading = false
      }
    }
  }
}
</script>
